import React from 'react';
import { useEffect } from 'react';
import { useWidgetContext, WidgetContext } from './data/widgets/WidgetContext';

export default function WidgetContextProvider(props) {
    const [widgetContext] = useWidgetContext();

    useEffect(() => {
        if (props.location != null) {
            widgetContext.setWidget({
                widgetMatchId: null,
            });
        } else {
            widgetContext.setWidget({
                widgetStartCollapsed: true,
                widgetS5Layout: '#3'
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location]);

    return (
        <WidgetContext.Provider value={widgetContext}>
            {props.children}
        </WidgetContext.Provider>
    );
}
